module.exports = __webpack_public_path__ + "img/icon-industrial.f2056785.svg";